import axios from "axios";
import React, { Dispatch, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actionCreators as StudnetCreator } from "@/store/student";
import Select from "react-select";
import Swal from "sweetalert2";
import Line from "./Chart/Line";
import { formatDateTime as format } from "@/helpers/func";
import { Translate } from "@/helpers/Translate";
import ClubsModal from "./ClubsModal";
import SupplyListModal, { SupplyList } from "./SupplyListModal";

const t = new Translate();

export default function ViewStudents() {
  const dispatch: Dispatch<any> = useDispatch();
  const students = useSelector((state: any) => state.Student.students);
  const guardian = useSelector((state: any) => state.Parent.guardian);
  const [clubsModal, setclubsModal] = useState<any>(false);
  const [selectedClubs, setSelectedClubs] = useState<any[]>([]);
  const [supplyListModal, setSupplyListModal] = useState<boolean>(false);
  const [selectedSupplyLists, setSelectedSupplyLists] = useState<SupplyList[]>([]);
  const [supplyListStudent, setSupplyListStudent] = useState<string>("");
  useEffect(() => {
    dispatch(StudnetCreator.GetStudents({ id: guardian.id }));
  }, [dispatch, guardian.id]);

  const handleGoToStPortal = (e: React.MouseEvent, st: any) => {
    let body = st;
    body["guardian"] = guardian;
    axios.post(
      `${process.env.REACT_APP_GO_TO_STDU_PORTAL}auth/parentlogin.php`,
      body
    );
  };
  const handleChangeClub = (e: any, student_id: any) => {
    Swal.showLoading();
    axios
      .post(`${process.env.REACT_APP_BASEURL}student/setclub.php`, {
        student_id: student_id,
        club_id: e.value,
      }).then(()=>{
        Swal.fire(t.translate('Success'), t.translate('Club Assigned successfully'),'success').then(()=>{
          dispatch(StudnetCreator.GetStudents({ id: guardian.id }));
        Swal.close();
        })
      }).catch((error)=>{
        console.log(error.response.data.msg);
        Swal.fire(t.translate('Failed to assign club'), t.translate(error.response.data.msg),'error').then(()=>{
          dispatch(StudnetCreator.GetStudents({ id: guardian.id }));
        Swal.close();
        })
      })
     
  };

  return (
    <div className="row">
      {students?.map((student: any) => {
        console.log(student.clubs);
        return (
          <div className="col-md-6" key={student.id}>
            <div
              className="card shadow-sm p-3 mb-5 bg-white"
              style={{ width: "22rem", borderRadius: "16px" }}
            >
              <br />
              {student.driveid ? (
                <img
                  src={ student.driveid?.includes("https://")?student.driveid:`https://drive.google.com/uc?id=${student.driveid}&export=download`}
                  className="card-img-top"
                  alt="..."
                  style={{
                    width: "20rem",
                    alignSelf: "center",
                    borderRadius: "5px",
                  }}
                />
              ) : (
                <img
                  src="./static/media/avatar.3aaad4fe.jpeg"
                  className="card-img-top"
                  alt="..."
                  style={{
                    width: "20rem",
                    alignSelf: "center",
                    borderRadius: "5px",
                  }}
                />
              )}

              <div className="card-body">
                <h5 className="card-title">{student.fullname}</h5>
                <p className="card-text"></p>
              </div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">{t.translate("Grade")} : {student.grade}</li>
                {/* <li className="list-group-item">A second item</li>
                  <li className="list-group-item">A third item</li> */}
              </ul>
              <div className="card-body pr-0 pl-0">
                {(() => {
                  const studentRP = (student.Reinforcements || []).reduce(
                    (acc: number, item: any) => acc + Number(item.student_points ?? item.points ?? 0),
                    0
                  );
                  return (
                    <>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h5 className="card-title mb-0">{t.translate("Reinforcement points")}</h5>
                        <span
                          className={`badge ${
                            studentRP > 0 ? "bg-success text-white" : studentRP < 0 ? "bg-danger text-white" : "bg-secondary text-white"
                          }`}
                          style={{
                            backgroundColor: studentRP > 0 ? "#28a745" : studentRP < 0 ? "#dc3545" : "#6c757d",
                            fontSize: "13px",
                            padding: "4px 8px",
                            fontWeight: "bold",
                            borderRadius: "4px",
                          }}
                        >
                          {studentRP > 0 ? `+${studentRP}` : studentRP}
                        </span>
                      </div>
                      <Link
                        className="mb-5 d-block"
                        to={`/dashboard/viewstudents/${student.id}/Reinforcement-point`}
                      >
                        <Line color="blue" Reinforcements={student.Reinforcements} />
                      </Link>
                    </>
                  );
                })()}
              </div>
              <div className="card-body">
                <h5 className="card-title">{t.translate("Preferred Club")} <button onClick={()=>{
                  setSelectedClubs(student.clubs);
                  setclubsModal(true);
                }} className="btn btn-success">{t.translate("view clubs")} </button></h5>
                <Select
                  options={student.clubs}
                  defaultValue={student.clubs.find(
                    (i: any) => i.value == student.club
                  )}
                  onChange={(e) => {
                    handleChangeClub(e, student.id);
                  }}
                  isDisabled={
                    format(new Date(), "yyyy-MM-dd") >= student.lockeddate ||
                    !student.lockeddate
                  }
                />
              </div>
              <div className="card-body">
                {/* <a href="#" className="card-link">Card link</a>
                  <a href="#" className="card-link">Another link</a> */}
                <Link
                  className="btn btn-success text-center fw-bold"
                  to={`/dashboard/viewstudents/${student.id}/progress-report`}
                >
                  {t.translate("Progress Card")}
                </Link>

                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`https://student.ivyis.org/backend/store.php?jwt=${student.jwt}`}
                  className="btn btn-primary text-center fw-bold ms-3 text-light"
                >
                  {t.translate("Profile")}
                </a>
                <Link
                  className="btn btn-info text-center fw-bold my-3 " 
                  to={`/dashboard/viewstudents/${student.id}/map-growth`}
                >
                  {t.translate("Map Growth")}
                </Link>
                {student.grade_id < "5" ? (
                  <Link
                    className="btn btn-warning my-3 mx-2 text-center fw-bold"
                    to={`/dashboard/classactivities/${student.id}`}
                  >
                    {t.translate("Daily Activities")}
                  </Link>
                ) : null}
                {student.supplylists?.length === 1 ? (
                  <a
                    className="btn btn-secondary my-3 me-2 text-center fw-bold text-light"
                    href={student.supplylists[0].fileurl}
                    target="_blank"
                    rel="noreferrer"
                    download
                  >
                    {t.translate("Download Supply List")}
                  </a>
                ) : student.supplylists?.length > 1 ? (
                  <button
                    className="btn btn-secondary my-3 me-2 text-center fw-bold"
                    onClick={() => {
                      setSelectedSupplyLists(student.supplylists);
                      setSupplyListStudent(student.fullname);
                      setSupplyListModal(true);
                    }}
                  >
                    {t.translate("Download Supply List")}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
      <ClubsModal
        isOpen={clubsModal}
        toggle={() => setclubsModal(!clubsModal)}
        clubs={selectedClubs}
      />
      <SupplyListModal
        isOpen={supplyListModal}
        toggle={() => setSupplyListModal(!supplyListModal)}
        supplyLists={selectedSupplyLists}
        studentName={supplyListStudent}
      />
    </div>
  );
}
